<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-page-header @back="onBack" title="" content="學生平台教學圖片">
        </el-page-header>
      </el-col>
    </el-row>
    <div class="page-box">
      <el-form label-position="top" label-width="80px" :model="formLabelAlign">
        <el-form-item>
          <div slot="label">
            <div class="label-text">教學圖片</div>
          </div>
          <draggable
            v-model="formLabelAlign.unitIds"
            @update="draggableUpdate"
            animation="300"
            handle=".mover"
          >
            <el-row
              v-for="(item, index) in formLabelAlign.unitIds"
              :key="index"
              :gutter="20"
              type="flex"
              align="bottom"
              class="unit-list"
            >
              <el-col :span="4">
                <upload
                  :imageurl="item.image"
                  @childByValue="childByValue(index, $event)"
                ></upload>
              </el-col>
              <el-col :span="6">
                視頻鏈接：
                <el-input v-model="item.url"></el-input>
              </el-col>
              <el-col :span="3">
                類型：
                <el-select v-model="item.type" placeholder="類型">
                  <el-option label="image" value="image"></el-option>
                  <el-option label="video" value="video"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2">
                <i
                  v-if="formLabelAlign.unitIds.length > 1"
                  class="el-icon-rank mover"
                ></i
              ></el-col>
              <el-col :span="2">
                <i
                  v-if="formLabelAlign.unitIds.length > 1"
                  class="el-icon-close"
                  @click="onIconClose(index)"
                ></i
              ></el-col>
            </el-row>
          </draggable>
          <div
            class="plus-outline-add text-line-button cursor-pointer"
            @click="onAdd"
          >
            <i class="el-icon-circle-plus-outline"></i>添加更多圖片
          </div>
        </el-form-item>
        <div class="page-button">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="onBack">取消</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getBanners, addBatchEditBanners } from "@/api/setting";
import upload from "@/components/upload";
import draggable from "vuedraggable";
export default {
  components: { draggable, upload },
  data() {
    return {
      formLabelAlign: {
        unitIds: [{
          image:"",
          url:"",
          type:"image"
        }],
      },
    };
  },
  created() {
    this.getBanners();
  },
  methods: {
    draggableUpdate() {},
    onSubmit() {
      this.addBatchEditBanners();
    },
    childByValue(index, value) {
      this.formLabelAlign.unitIds[index].image = value;
      this.$forceUpdate();
    },
    onIconClose(index) {
      this.formLabelAlign.unitIds.splice(index, 1);
    },
    onAdd() {
      this.formLabelAlign.unitIds.push({image:'',url:'',type:'image'});
    },
    addBatchEditBanners() {
      let from = {
        banners: this.formLabelAlign.unitIds,
      };
      addBatchEditBanners(from).then(() => {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.getBanners()
      });
    },
    onBack() {
      this.$router.go(-1);
    },
    getBanners() {
      getBanners().then((res) => {
       this.formLabelAlign.unitIds = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  background-color: #fff;
  padding: 20px;
  margin-top: 20px;
}
.unit-list {
  margin-bottom: 20px;
}
.plus-outline-add {
  display: inline-block;
}
</style>